export const CLIENT_BRAND_NAME = 'FieldOps Notes' as const;
